export default __webpack_public_path__ + "static/media/(60).5296f8dd.jpg";